import { styled } from '@mui/material/styles';
import CardContent from '@mui/material/CardContent';

export const BlueCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
  background: 'rgba(245, 247, 251, 0.76)',
  borderRadius: '4px'
}));

export default BlueCardContent;
